export const formatNumber = (n) => new Intl.NumberFormat('en-IN').format(n);

export const formatCompact = (n) =>
  new Intl.NumberFormat('en-IN', { notation: 'compact', maximumFractionDigits: 2 }).format(n);

export const formatCurrency = (n) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n);

export const formatPercent = (n, digits = 1) => `${Number(n).toFixed(digits).replace(/\.0+$/, '')}%`;

// % change between current and previous period. Returns null when it cannot be computed.
export function changePct(current, previous) {
  if (!Number.isFinite(current) || !Number.isFinite(previous) || previous === 0) return null;
  return ((current - previous) / previous) * 100;
}
